export type StatisticsPreviewMembershipCtaCopy = {
  title: string;
  description: string;
};

type StatisticsPreviewMembershipCtaCopyOptions = {
  isFirstPaymentUser?: boolean;
};

export const STATISTICS_PREVIEW_MEMBERSHIP_URL = 'https://app.sellerbox.io/m/membership';
const KOREA_TIME_ZONE = 'Asia/Seoul';
const LIMITED_EARLY_BIRD_CTA_START_DATE_KEY = '2026-05-27';
const LIMITED_EARLY_BIRD_CTA_END_DATE_KEY = '2026-06-30';

export const STATISTICS_PREVIEW_MEMBERSHIP_CTA_DEFAULT: StatisticsPreviewMembershipCtaCopy = {
  title: '셀러박스 멤버십 이용하기',
  description: '판매 관리를 계속 이용하려면 멤버십을 시작하세요!',
};

export const STATISTICS_PREVIEW_MEMBERSHIP_CTA_LIMITED_EARLY_BIRD = {
  title: '6월 30일까지 가입하면 3개월 월 100원',
  description: '얼리버드 혜택이 곧 종료됩니다. 지금 바로 시작하세요.',
} satisfies StatisticsPreviewMembershipCtaCopy;

export const STATISTICS_PREVIEW_MEMBERSHIP_CTA_FIRST_PAYMENT = {
  title: '지금 가입하면 첫 달 100원',
  description: '부담 없이 시작해보세요. 첫 결제에 한해 적용돼요.',
} satisfies StatisticsPreviewMembershipCtaCopy;

const getKoreanCalendarDateKey = (date: Date): string => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: KOREA_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  const year = parts.find((part) => part.type === 'year')?.value ?? '';
  const month = parts.find((part) => part.type === 'month')?.value ?? '';
  const day = parts.find((part) => part.type === 'day')?.value ?? '';

  return `${year}-${month}-${day}`;
};

export const isStatisticsPreviewLimitedEarlyBirdCtaPeriod = (date = new Date()): boolean => {
  const koreanDateKey = getKoreanCalendarDateKey(date);

  return (
    koreanDateKey >= LIMITED_EARLY_BIRD_CTA_START_DATE_KEY &&
    koreanDateKey <= LIMITED_EARLY_BIRD_CTA_END_DATE_KEY
  );
};

export const getStatisticsPreviewMembershipCtaCopy = (
  date = new Date(),
  options: StatisticsPreviewMembershipCtaCopyOptions = {},
): StatisticsPreviewMembershipCtaCopy => {
  if (isStatisticsPreviewLimitedEarlyBirdCtaPeriod(date)) {
    return STATISTICS_PREVIEW_MEMBERSHIP_CTA_LIMITED_EARLY_BIRD;
  }

  if (options.isFirstPaymentUser === true) {
    return STATISTICS_PREVIEW_MEMBERSHIP_CTA_FIRST_PAYMENT;
  }

  return STATISTICS_PREVIEW_MEMBERSHIP_CTA_DEFAULT;
};

export const buildStatisticsPreviewMembershipUrl = (cplatToken?: unknown): string => {
  const token = typeof cplatToken === 'string' ? cplatToken.trim() : '';

  if (!token) {
    return STATISTICS_PREVIEW_MEMBERSHIP_URL;
  }

  const queryParams = new URLSearchParams({
    cplatToken: token,
  });

  return `${STATISTICS_PREVIEW_MEMBERSHIP_URL}?${queryParams.toString()}`;
};
